export default __webpack_public_path__ + "static/1-78ecbb69fd7a7b85f0144c6dbd03c52c.jpg";